import { SvgIconsMap } from '@design/design-tokens/iconography/SvgIcons';

export const isValidIcon = (name: string): name is keyof typeof SvgIconsMap =>
  name in SvgIconsMap;
